module.exports = __webpack_public_path__ + "img/max.8e246293.svg";